<ng-container *ngIf="paymentForm">
	<form [formGroup]="paymentForm" (ngSubmit)="addPayment()" class="text-dark border-1">
		<div class="row m-0 p-0">
			<div class="col-md-2 text-right text-dark m-0 p-0 d-none">
					<div class="ml-auto" *ngIf="bankaccounts && !pos">
						<mat-form-field appearance="outline">
							<mat-label>Bank Account</mat-label>
							<mat-select formControlName="bankaccount">
								<mat-option *ngFor="let method of bankaccounts" [value]="method.accountcode">
									{{method.bankaccountname }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="ml-auto " >
					</div>
			</div>
			<div class="col-12 col-md-7 m-0 p-0">
				<div class="card">
					<h1 class="card-header text-center border-{{color}}">
						<span *ngIf="getBalance() < 0 && change_due < 0" class="text-successdue">CHANGE DUE {{ getBalance() | abs | currency }}</span>
						<span *ngIf="getBalance() < 0 && change_due >= 0" class="text-danger">OVER PAYMENT {{ getBalance() | abs | currency }}</span>
						<span *ngIf="getBalance() > 0 " class="text-danger">DUE {{ getBalance() | abs | currency }}</span>
					</h1>
					<div class="card-body">
						<table class="ml-auto mr-0 table table-totals w-100 " *ngIf="totals && totals.length">
							<thead></thead>
							<tbody>
								<tr *ngFor="let t of totals">
									<td class="text-left dotted"><b>{{ t.title }}:</b></td>
									<td class="text-right dotted"> {{ t.text | currency}}</td>
								</tr>
								<tr *ngIf="appliedCredits.length">
									<th class="text-left border-bottom"><b>Credits Applied</b></th>
									<th class="text-right border-bottom"></th>
								</tr>
								<ng-container *ngFor="let credit of appliedCredits">
									<tr>
										<td class="text-left dotted"><mat-icon class="text-danger" (click)="removeCredit(credit)">remove</mat-icon>#{{credit.orderno}}</td>
										<td class="text-right dotted">{{credit.applied | currency}}</td>
									</tr>
								</ng-container>
								<tr>
									<th class="border-bottom"><b>PAYMENTS</b></th>
									<th class="border-bottom"></th>
								</tr>
								<ng-container *ngIf="!payments || !payments.length">
									<td class="border-bottom"></td>
									<td class="border-bottom text-right"><b>NO PAYMENTS</b></td>
								</ng-container>

								<tr *ngFor="let pay of payments">
									<td class="text-right dotted">
										<mat-icon-button color="accent" class="mt-4 ml-1" (click)="removePayment(pay.payment_id)">
											<mat-icon color="accent" >cancel</mat-icon>
										</mat-icon-button>
										<b>{{ pay.payment_type }}</b> <span style="font-size:10pt" *ngIf="pay.reference" class="d-inline">{{lastFour(pay.reference) }} </span> <span *ngIf="pay.options" class="d-inline">{{lastFour(pay.options.number) }} </span>

									</td>
									<td class="text-right dotted">{{ pay.amount | currency }}</td>
								</tr>
								<ng-container *ngFor="let card of appliedGiftCards">
									<tr>
										<td class="text-left dotted"><mat-icon class="text-danger" (click)="removeCard(card)">remove</mat-icon>{{lastFour(card.giftcard_number)}}</td>
										<td class="text-right dotted">{{card.applied | currency}}</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
						<div class="item-box">
							<table class="ml-auto mr-0 table table-totals w-100 table-sticky">
								<tbody>
									<tr>
										<th class="normal-semilarge">ITEMS</th>
										<th class="normal-semilarge text-right">QTY@PRICE</th>
										<th class="normal-semilarge text-right">T</th>
									</tr>
									<ng-container *ngIf="items && items.length">
									<tr *ngFor="let i of items">
										<td *ngIf="i.option && i.option?.coupon_id" class="text-left dotted normal"><b>{{ i.name }} - {{i.description}}:</b></td>
										<td *ngIf="!i.option || !i.option?.coupon_id" class="text-left dotted normal"><b>{{ i.name }}:</b></td>										
										<td class="text-right dotted normal"> {{ i.quantity }}&nbsp;@&nbsp;{{ i.price | currency}}</td>
										<td class="text-right dotted normal">
											<span *ngIf="i.taxtotal != 0"><b>T</b></span>
											<span *ngIf="i.taxtotal == 0"></span>
										</td>
									</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-5 ">
				<ng-container *ngIf="paymentForm">
					<div class="row m-0 p-0">
						<div class="col-md-12">
							<div class="terminal-in-progress-banner mb-2" *ngIf="terminalTransactionInProgress">
								<mat-icon class="banner-icon">credit_card</mat-icon>
								<span>Terminal payment in progress — complete the transaction on the device or in the dialog.</span>
								<mat-spinner diameter="24" class="banner-spinner"></mat-spinner>
							</div>
							<h3 class="mt-2 mb-2 text-center"><b>Payment Method</b></h3>
							<h5 class="text-center">
								<mat-slide-toggle
									class="text-center ml-auto mr-auto"
									[formControl]="refund"
									(click)="makeNegativePayment()"
									*ngIf="getBalance() < 0 ">
									REFUND
								</mat-slide-toggle>
							</h5>
							<!-- Terminal configured: terminal is the default; non-card methods sit alongside it -->
							<div class="pos-pay-methods" *ngIf="hasTerminalConfigured">
								<!-- Terminal and card-on-file are stacked. Directional exclusivity:
								     a queued profile payment drops the terminal tile; a terminal charge drops card-on-file. -->
								<div class="pos-pay-primary-row">
									<button type="button" class="pos-terminal-option" *ngIf="cardPathTaken !== 'profile'" [class.active]="terminalSelected && !useOtherPaymentMethod" (click)="selectTerminalPayment()">
										<span class="pos-terminal-option__icon"><mat-icon>credit_card</mat-icon></span>
										<span class="pos-terminal-option__text">
											<span class="pos-terminal-option__title">Terminal</span>
											<span class="pos-terminal-option__sub">{{ selectedTerminal?.terminal_name || 'Card terminal' }}</span>
										</span>
										<mat-icon class="pos-terminal-option__check" *ngIf="terminalSelected && !useOtherPaymentMethod">check_circle</mat-icon>
									</button>
									<ng-container *ngIf="cardPathTaken !== 'terminal'">
										<ng-container *ngTemplateOutlet="useCardButton"></ng-container>
									</ng-container>
								</div>

								<!-- Add card + saved-card picker -->
								<ng-container *ngIf="cardPathTaken !== 'terminal'">
									<ng-container *ngTemplateOutlet="cardOnFileOptions"></ng-container>
								</ng-container>

								<ng-container *ngIf="!terminalFallback">
									<ng-container *ngIf="nonCardPaymentMethods().length">
										<div class="pos-pay-divider"><span>or</span></div>
										<div class="payment-method-toggles-wrap">
											<mat-button-toggle-group aria-label="Charge" (change)="setChargeType($event)" formControlName="type" class="payment-method-toggle-group">
												<mat-button-toggle *ngFor="let method of nonCardPaymentMethods()" [value]="method.paymentname">
													{{ method.paymentname }}
												</mat-button-toggle>
											</mat-button-toggle-group>
										</div>
									</ng-container>
									<div class="pos-pay-fallback-link">
										<a href="javascript:void(0)" (click)="enableTerminalFallback()">Enter manually</a>
									</div>
								</ng-container>

								<ng-container *ngIf="terminalFallback">
									<div class="pos-pay-divider"><span>manual entry</span></div>
									<div class="payment-method-toggles-wrap">
										<mat-button-toggle-group aria-label="Charge" (change)="setChargeType($event)" formControlName="type" class="payment-method-toggle-group">
											<ng-container *ngFor="let method of paymentmethods">
												<mat-button-toggle [value]="method.paymentname" *ngIf="(pos && method.pos_enabled ==='1') || !pos">
													{{ method.paymentname }}
												</mat-button-toggle>
											</ng-container>
										</mat-button-toggle-group>
									</div>
								</ng-container>
							</div>

							<!-- No terminal: full method list as modern pills -->
							<div class="pos-pay-methods" *ngIf="!hasTerminalConfigured && paymentmethods && paymentmethods.length">
								<div class="payment-method-toggles-wrap">
									<mat-button-toggle-group aria-label="Charge" (change)="setChargeType($event)" formControlName="type" class="payment-method-toggle-group">
										<ng-container *ngFor="let method of paymentmethods">
											<mat-button-toggle [value]="method.paymentname" *ngIf="(pos && method.pos_enabled ==='1') || !pos">
												{{ method.paymentname }}
											</mat-button-toggle>
										</ng-container>
									</mat-button-toggle-group>
								</div>
								<!-- Card on file (use / add) — also available without a terminal -->
								<ng-container *ngIf="cardPathTaken !== 'terminal'">
									<ng-container *ngTemplateOutlet="useCardButton"></ng-container>
									<ng-container *ngTemplateOutlet="cardOnFileOptions"></ng-container>
								</ng-container>
							</div>

							<!-- Shared card-on-file options; rendered in both terminal and no-terminal layouts.
							     Gating lives in canUseCardOnFile()/canAddCardOnFile() — independent of hasTerminalConfigured. -->
							<!-- Use-card-on-file button -->
							<ng-template #useCardButton>
								<button type="button" class="pos-terminal-option pos-terminal-option--cof" *ngIf="canUseCardOnFile()" [class.active]="useOtherPaymentMethod && card_required && !addingCardOnFile" (click)="selectCardOnFilePayment()">
									<span class="pos-terminal-option__icon"><mat-icon>account_balance_wallet</mat-icon></span>
									<span class="pos-terminal-option__text">
										<span class="pos-terminal-option__title">Card on file</span>
										<span class="pos-terminal-option__sub">{{ profile_cards.length }} saved card{{ profile_cards.length === 1 ? '' : 's' }}</span>
									</span>
									<mat-icon class="pos-terminal-option__check" *ngIf="useOtherPaymentMethod && card_required">check_circle</mat-icon>
								</button>
							</ng-template>

							<ng-template #cardOnFileOptions>
								<button type="button" class="pos-terminal-option pos-terminal-option--cof" *ngIf="canAddCardOnFile()" [class.active]="addingCardOnFile" (click)="startAddCardOnFile()">
									<span class="pos-terminal-option__icon"><mat-icon>credit_card</mat-icon></span>
									<span class="pos-terminal-option__text">
										<span class="pos-terminal-option__title">Add card to file</span>
										<span class="pos-terminal-option__sub">Save a card to this customer's profile</span>
									</span>
									<mat-icon class="pos-terminal-option__check" *ngIf="addingCardOnFile">check_circle</mat-icon>
								</button>

								<!-- Cards-on-file list sits directly under the "Use card on file" option -->
								<ng-container *ngIf="card_required && posCardpointeEnabled">
									<div class="cof-picker__loading" *ngIf="loadingcards">
										<svg class="spinner" width="18px" height="18px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
										<span>Loading saved cards…</span>
									</div>
									<div class="cof-picker" *ngIf="!loadingcards">
										<div class="cof-picker__label">Cards on file ({{ profile_cards.length }})</div>
										<div class="cof-card"
											*ngFor="let card of profile_cards"
											[class.cof-card--active]="paymentForm.get('card_selected').value === card"
											(click)="selectSavedCard(card)">
											<i class="cof-card__brand fa" [ngClass]="cardBrandIcon(card)"></i>
											<span class="cof-card__num">•••• {{ cardLast4(card) }}</span>
											<span class="cof-card__meta">
												<span class="cof-card__name">{{ card.name | htmlToText }}</span>
												<span class="cof-card__exp">exp {{ card.expiry_month }}/{{ card.expiry_year }}</span>
											</span>
											<span class="cof-card__default" *ngIf="card.default">DEFAULT</span>
											<i class="cof-card__check fa fa-check-circle" *ngIf="paymentForm.get('card_selected').value === card"></i>
											<button type="button" class="cof-card__remove" title="Remove card" (click)="removeSavedCard(card, $event)">
												<i class="fa fa-trash"></i>
											</button>
										</div>
										<button type="button" class="cof-add-link" (click)="startAddCardOnFile()">
											<i class="fa fa-plus"></i> Add a new card
										</button>
									</div>
								</ng-container>

							</ng-template>

							<!-- <mat-form-field appearance="outline" class="pay-panel" *ngIf="pos">
								<mat-label>Payment Type</mat-label>
								<mat-select formControlName="type" (selectionChange)="updatePaymentType($event, false)" panelClass="pay-panel">
									<mat-option [value]="''">SELECT A PAYMENT TYPE</mat-option>
									<ng-container *ngFor="let method of paymentmethods">
										<mat-option *ngIf="( (pos && method.pos_enabled )|| !pos) == 1" [value]="method.paymentname">
											{{method.paymentname }}
										</mat-option>
									</ng-container>
								</mat-select>
							</mat-form-field> -->


							<ng-container *ngIf="preselected_payment && loadingcards">
								<div class="text-center" class="col-md-12">
									<h5 class="text-danger">Pre Selected Payment Loading Profile</h5>
									<span>
										<svg class="spinner" width="15px" height="15px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
											<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
										</svg>
									</span>
								</div>
							</ng-container>


						</div>

					</div>
					<div class="rainbowboard mt-0 mb-0">
						<!-- Custom amount field (no Angular Material) -->
						<div class="pos-amount">
							<span class="pos-amount__label">Amount</span>
							<div class="pos-amount__field">
								<button type="button" class="pos-amount__clear" (click)="paymentForm.get('amount').setValue(0)" *ngIf="getBalance() != 0" aria-label="Clear amount">&times;</button>
								<input type="text" #amountId class="pos-amount__input" placeholder="0.00" aria-label="Amount" formControlName="amount" inputmode="decimal" (input)="paymentForm.get('amount').markAsTouched()" />
							</div>
						</div>
						<div class="col-md-12" *ngIf="addOnRequired()">
						<div class="pos-reference">
							<span class="pos-amount__label">Reference</span>
							<div class="pos-amount__field">
								<button type="button" class="pos-amount__clear" (click)="giftcardSearch()" *ngIf="showGCButton()" aria-label="Search">?</button>								
								<input type="text" class="pos-amount__input" placeholder="Reference" aria-label="Amount" formControlName="reference"  appSelectOnFocus />
							</div>
						</div>	
						</div>
						<!-- Persistent action row: keypad toggle + ADD. The number pad itself collapses
						     so Amount + ADD (and the COMPLETE button below) stay visible without scrolling. -->
						<div class="pos-pay-actions">
							<button type="button" class="pos-keypad-toggle" [class.active]="showKeypad" (click)="toggleKeypad()">
								<mat-icon>dialpad</mat-icon>
								<span>{{ showKeypad ? 'Hide keypad' : 'Keypad' }}</span>
							</button>
							<button type="button" class="pos-add-btn" [disabled]="submitting" (click)="runKey('add')">{{ submitting ? 'PROCESSING…' : 'ADD' }}</button>
						</div>

						<div class="pos-keypad-grid" *ngIf="showKeypad">
							<div class="rainbowboard-inner">
								<div class="key">
									<div class="rainbow-content" (click)="runKey(7)">7</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(8)">8</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(9)">9</div>
								</div>
							</div>
							<div class="rainbowboard-inner">
								<div class="key">
									<div class="rainbow-content" (click)="runKey(4)">4</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(5)">5</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(6)">6</div>
								</div>
							</div>
							<div class="rainbowboard-inner">
								<div class="key">
									<div class="rainbow-content" (click)="runKey(1)">1</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(2)">2</div>
								</div>
								<div class="key">
									<div class="rainbow-content" (click)="runKey(3)">3</div>
								</div>
							</div>
							<div class="rainbowboard-inner">
								<div class="key" (click)="runKey('0')">
									<div class="rainbow-content">0</div>
								</div>
								<div class="key" (click)="runKey('.')">
									<div class="rainbow-content">.</div>
								</div>
								<div class="key" (click)="runKey('backspace')">
									<div class="rainbow-content">
										<mat-icon>keyboard_backspace</mat-icon>
									</div>
								</div>
								<div class="key" (click)="runKey('minus')" *ngIf="getBalance() < 0 ">
									<div class="rainbow-content minus" >
										<span *ngIf="!isNegative()">-</span>
										<span *ngIf="isNegative()">+</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</form>
</ng-container>

<!-- Add-card-to-file modal -->
<ng-template #addCardModal>
	<div class="cof-modal__head">
		<h3 class="cof-modal__title"><i class="fa fa-credit-card"></i> Add a card to file</h3>
		<button type="button" class="cof-modal__close" aria-label="Close" (click)="closeAddCardModal()">&times;</button>
	</div>
	<div class="cof-modal__body">
		<app-credit-card-form [customer]="cardFormCustomer" [type]="'orderentry'" [hideShipTo]="true" (updatePayments)="onCardOnFileAdded($event)"></app-credit-card-form>
	</div>
	<div class="cof-modal__foot">
		<button type="button" class="cof-modal__cancel" (click)="closeAddCardModal()">Cancel</button>
	</div>
</ng-template>
<!-- Select GiftCard Modal -->
<ng-template #gcModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Apply Gift Card(s)</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body" >
		<div class="mb-3">
			<div class="row">
			<div class="col-sm-12">
			<mat-form-field appearance="outline">
				<mat-label>Card Number</mat-label>
				<input matInput type="text" [formControl]="cardNumberSearch" />
			</mat-form-field>
			</div>
			</div>
			<table class="p-2 m-auto table-striped table-bordered" *ngIf="giftcardselect">
				<tr>
					<th class="col-auto text-center">Card Number</th>
					<th class="col-auto text-center">Balance</th>
					<th class="col-auto text-center">Comment</th>
					<th class="col-auto text-center">Reference</th>
					<th class="col-auto text-center">Customer</th>
					<th></th>
				</tr>
				<tr *ngFor="let card of giftcardselect" [ngClass]="card.applied > 0 ? 'credit-row-hl' : ''">
					<td class="col-auto font-weight-lighter text-center">{{card.giftcard_number}}</td>
					<td class="col-auto font-weight-lighter text-center">{{card.balance | currency}}</td>
					<td class="col-auto font-weight-lighter text-center">{{card.comment}}</td>
					<td class="col-auto font-weight-lighter text-center">{{card.branchcode}}</td>
					<td class="col-auto text-center">{{card.debtorno}}</td>
					<td class="">
						<button class="w-100 m-0 p-0" mat-flat-button color="primary" [disabled]="getBalance() <= 0" (click)="gcSelected(card)" *ngIf="!card.selected">
							<span>Apply</span>
						</button>
					</td>
				</tr>
			</table>
		</div>
	</div>
	<div class="modal-footer">
		<div class="row m-0 p-0 w-100 d-flex justify-content-end" *ngIf="this.getBalance() < 0">
			<mat-label class="float-right text-danger italics">Gift cards can only be applied to a positive balance</mat-label>
		</div>
	</div>
</ng-template>
